const __WEBPACK_NAMESPACE_OBJECT__ = require("inject-browser-sync-webpack-plugin");